import React, { useEffect, useMemo, useState } from "react";
import {
  formatDataVmailNatcomCompate,
  getDateChangeTime,
} from "../../../../helper/helper";
import { TYPE_GET_DATE } from "../../../../helper/const";
import FilterTime from "../../../components/FilterTime";
import { useSelector } from "react-redux";
import DashboardCompare from "../../components/DashboardCompare";
import { Tabs } from 'antd';
const { TabPane } = Tabs;

export default function Compare({ tabActive, handleGetData }) {
  const [startDate, setStartDate] = useState(
    getDateChangeTime(TYPE_GET_DATE.oneDayAgo)
  );
  const [endDate, setEndDate] = useState(getDateChangeTime(TYPE_GET_DATE.now));
  const { result = {} } =
    useSelector((state) => state.reducerNatcom?.data) || {};
  const { data: airtime = [] } = result;

  useEffect(() => {
    if (tabActive !== "3") return;

    handleGetData(startDate, endDate);
  }, [startDate, endDate, tabActive]);

  const dataChartOrigin = useMemo(() => {
    const convertData = formatDataVmailNatcomCompate(
      airtime,
      startDate,
      endDate
    );
    return convertData || [];
  }, [airtime, startDate, endDate]);
  const dataChartAdvance = useMemo(() => {
    const convertData = formatDataVmailNatcomCompate(
      airtime,
      startDate,
      endDate,
      true
    );
    return convertData || [];
  }, [airtime, startDate, endDate]);
 
  return (
    <>
          <div
            className="position-relative d-flex justify-right mb-2"
            style={{ justifyContent: "right" }}
          >
            <FilterTime
              startDate={startDate}
              setStartDate={setStartDate}
              endDate={endDate}
              setEndDate={setEndDate}
            />
          </div>
     
      <Tabs defaultActiveKey="1">
        <TabPane tab="Tổng tiền thu hồi gốc + phí" key="1">
          <div>
            <DashboardCompare
              dataChart={dataChartOrigin}
              startDate={startDate}
              endDate={endDate}
            />
          </div>
        </TabPane>
        <TabPane tab="Tổng tiền ứng + phí" key="2">
          <div>
            <DashboardCompare
              dataChart={dataChartAdvance}
              startDate={startDate}
              endDate={endDate}
            />
          </div>
        </TabPane>
      </Tabs>
    </>
  );
}
